import { useTranslation } from "react-i18next";
import { usePreviousPeriodData } from "@pages/BillsPage/usePreviousPeriodData";
import { ButtonLink } from "@components/Button";
import { Notification } from "@components/Notification/Notification";
import { useOverviewQuery } from "@services/overview/queries";
import { convertYearMonthToDate } from "@utils/common";
import { sanitizeHtml } from "@utils/html";
import { formatDate } from "@utils/units";

export const UnpaidPreviousPeriodBillWarning = () => {
  const { t } = useTranslation();
  const { data: overview } = useOverviewQuery();
  const { shouldDisplayUnpaidWarning, previousPeriodLink } =
    usePreviousPeriodData();

  if (!shouldDisplayUnpaidWarning) {
    return null;
  }

  const previousPeriod =
    overview?.jointBillServices.find((jbs) => !!jbs.previousPeriod)
      ?.previousPeriod ?? {};
  const date = convertYearMonthToDate(previousPeriod);

  return (
    <Notification
      color="red"
      description={
        <span
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(
              t("unpaidPreviousPeriodBillWarning.description", {
                date: formatDate(date, t("common.dateFormat.yearMonth")),
              }),
            ),
          }}
        />
      }
      button={
        <ButtonLink variant="link" href={previousPeriodLink}>
          {t("unpaidPreviousPeriodBillWarning.button")}
        </ButtonLink>
      }
    />
  );
};
